import React, { useState, Fragment } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';

const CareerPage = () => {
    const [forms, setForms] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        summary: '',
        resume: null,
        photo: null,
    });

    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value });
        if (validator.allValid()) {
            validator.hideMessages();
        }
    };

    const fileHandler = (e) => {
        setForms({ ...forms, [e.target.name]: e.target.files[0] });
    };

    const submitHandler = e => {
        e.preventDefault();
        if (validator.allValid()) {
            alert("Application submitted successfully!");
            setForms({
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                address: '',
                summary: '',
                resume: null,
                photo: null,
            });
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    return (
        <Fragment>
            <main className="page_content career-page">
                <PageTitle pageTitle={'Career'}  />
            </main>
            <div className="container mt-5 mb-5">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <form onSubmit={submitHandler} className="career-form">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="input_title" htmlFor="firstName">First Name *</label>
                                        <input
                                            value={forms.firstName}
                                            type="text"
                                            name="firstName"
                                            className="form-control"
                                            onBlur={changeHandler}
                                            onChange={changeHandler}
                                            placeholder="John"
                                        />
                                        {validator.message('firstName', forms.firstName, 'required|alpha')}
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="input_title" htmlFor="lastName">Last Name *</label>
                                        <input
                                            value={forms.lastName}
                                            type="text"
                                            name="lastName"
                                            className="form-control"
                                            onBlur={changeHandler}
                                            onChange={changeHandler}
                                            placeholder="Doe"
                                        />
                                        {validator.message('lastName', forms.lastName, 'required|alpha')}
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="input_title" htmlFor="email">Email *</label>
                                        <input
                                            value={forms.email}
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            onBlur={changeHandler}
                                            onChange={changeHandler}
                                            placeholder="john.doe@example.com"
                                        />
                                        {validator.message('email', forms.email, 'required|email')}
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="input_title" htmlFor="phone">Phone *</label>
                                        <input
                                            value={forms.phone}
                                            type="tel"
                                            name="phone"
                                            className="form-control"
                                            onBlur={changeHandler}
                                            onChange={changeHandler}
                                            placeholder="+44 123 4567 890"
                                        />
                                        {validator.message('phone', forms.phone, 'required|phone')}
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="input_title" htmlFor="address">Address *</label>
                                        <input
                                            value={forms.address}
                                            type="text"
                                            name="address"
                                            className="form-control"
                                            onBlur={changeHandler}
                                            onChange={changeHandler}
                                            placeholder="City, Region, Country"
                                        />
                                        {validator.message('address', forms.address, 'required')}
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="input_title" htmlFor="summary">Summary *</label>
                                        <textarea
                                            value={forms.summary}
                                            name="summary"
                                            className="form-control"
                                            onBlur={changeHandler}
                                            onChange={changeHandler}
                                            placeholder="Write a short summary of yourself."
                                        />
                                        {validator.message('summary', forms.summary, 'required')}
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="input_title" htmlFor="resume">Resume * (PDF, DOC, DOCX, ODT, RTF)</label>
                                        <input
                                            type="file"
                                            name="resume"
                                            className="form-control"
                                            onChange={fileHandler}
                                            accept=".pdf, .doc, .docx, .odt, .rtf"
                                        />
                                        {validator.message('resume', forms.resume, 'required')}
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="input_title" htmlFor="photo">Photo (Optional)</label>
                                        <input
                                            type="file"
                                            name="photo"
                                            className="form-control"
                                            onChange={fileHandler}
                                            accept="image/*"
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="input_title" htmlFor="education">Education (Optional)</label>
                                        <textarea
                                            value={forms.education}
                                            name="education"
                                            className="form-control"
                                            placeholder="List your education details"
                                            onBlur={changeHandler}
                                            onChange={changeHandler}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="input_title" htmlFor="experience">Experience (Optional)</label>
                                        <textarea
                                            value={forms.experience}
                                            name="experience"
                                            className="form-control"
                                            placeholder="List your work experience"
                                            onBlur={changeHandler}
                                            onChange={changeHandler}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="input_title" htmlFor="coverLetter">Cover Letter (Optional)</label>
                                        <textarea
                                            value={forms.coverLetter}
                                            name="coverLetter"
                                            className="form-control"
                                            placeholder="Write your cover letter"
                                            onBlur={changeHandler}
                                            onChange={changeHandler}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <button type="submit" className="btn btn-primary">
                                        <span className="btn_label">Submit Application</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Scrollbar />
        </Fragment>
    );
}

export default CareerPage;
